/**
 * Ana SaaS pazarlama / kayıt hostu (otomanager.com, localhost, opsiyonel staging vb.).
 * Kiracı alt alan adları burada false döner; /legal gibi platform sayfaları her iki dalda da route edilir.
 */
import { MAIN_SAAS_PUBLIC_HOST } from "@/config/platformBrand";

export function isMainSaaSHost(hostname) {
  const h = String(hostname || "").toLowerCase();
  const isDev = process.env.NODE_ENV !== "production";
  const isLanIPv4 = isDev && /^(?:\d{1,3}\.){3}\d{1,3}$/.test(h);
  
  const root = MAIN_SAAS_PUBLIC_HOST; // otomanager.com
  const wwwRoot = `www.${root}`;
  
  const systemServices = [
    "webmail", "mail", "cpanel", "whm", "api", "admin",
    "autodiscover", "autoconfig", "owa", "smtp", "pop", "imap",
  ];
  const parts = h.split(".");
  const firstPart = parts[0];

  // Eğer bir subdomain varsa ve bu bir sistem servisi veya www değilse, bu ana SaaS hostu DEĞİLDİR (Kiracıdır).
  // Sistem servisleri sadece kök dizinin tam 1 seviye üstünde aranır (örn: www.otomanager.com).
  const isSubdomain = h.includes(".") && parts.length > root.split(".").length;
  const isSystemSubdomain = (parts.length === root.split(".").length + 1) && (systemServices.includes(firstPart) || firstPart === "www");

  const isPrimaryDomain = h.endsWith(root);

  const result = (
    h === "localhost" ||
    h === "127.0.0.1" ||
    h === "::1" ||
    isLanIPv4 ||
    h === root ||
    (isSubdomain && isSystemSubdomain && isPrimaryDomain)
  );

  if (process.env.NODE_ENV !== "production") {
    console.log("[Host Check]", { hostname: h, isMainSaaS: result });
  }
  return result;
}
